import queryString from 'query-string';

import { PATHS } from '@/constants';

export const getSessionsPageLinks = () => {
    const commonFilters = {
        channels: ['text', 'voice'],
        session_lengths: ['short', 'regular', 'long'],
        is_test: false
    };

    const buildLink = (extra?: Record<string, unknown>) =>
        queryString.stringifyUrl({
            url: PATHS.sessions,
            query: { ...commonFilters, ...extra }
        });

    return {
        totalSessionsCountLink: buildLink(),
        totalLeadCountLink: buildLink({ is_lead: true }),
        totalOpportunityCountLink: buildLink({ is_opportunity: true })
    };
};

export const CHART_HEIGHT_MOBILE = 280;
export const CHART_HEIGHT_DESKTOP = 380;
